import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { useDispatch, useSelector } from 'react-redux';
import { selectSortField } from '../../state/selectors/alertListSelectors';
import { setPageIndex, setSortField } from '../../state/slices/alertListSlice';

const SORT_FIELD_OPTIONS = [
  { label: 'Most Severe', value: 'mostSevere' },
  { label: 'Least Severe', value: 'leastSevere' },
  { label: 'Newest', value: 'newest' },
  { label: 'Oldest', value: 'oldest' },
];

/**
 * Renders the Alert List sort selector.
 *
 * @returns {JSX.Element} The sort field control.
 */
const AlertSortSelector = () => {
  const dispatch = useDispatch();
  const sortField = useSelector(selectSortField);
  const selectedSortField = sortField === 'severity' ? 'mostSevere' : sortField;

  return (
    <div style={{ width: 'min(100%, 16rem)' }}>
      <BaseSelect
        inputId="active-alert-sort-field"
        label="Sort by"
        isSearchable={false}
        selectProps={{
          'aria-label': 'Sort alerts by',
          options: SORT_FIELD_OPTIONS,
          value: SORT_FIELD_OPTIONS.find(({ value }) => value === selectedSortField),
          onChange: (option) => {
            dispatch(setSortField(option?.value ?? 'newest'));
            dispatch(setPageIndex(1));
          },
        }}
      />
    </div>
  );
};

export default AlertSortSelector;
